import { render, staticRenderFns } from "./MarketingReport.vue?vue&type=template&id=2889fc82&"
import script from "./MarketingReport.vue?vue&type=script&lang=ts&"
export * from "./MarketingReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports